<template>
	<v-card flat>
		<v-card-text class="pa-0 ma-0">
			<v-textarea
				:label="label"
				:rules="rules"
				:box="box"
				:hide-details="hideDetails"
				:auto-grow="autoGrow"
				:rows="rows"
				:value="value"
				@input="onInput"
				@change="onChange"
				@focus="inputFocused = true"
				@blur="inputFocused = false" />
		</v-card-text>

		<v-toolbar height="32" class="ma-0" dense card>
			<span v-if="inputFocused" class="caption font-italic grey--text text--darken-1">{{ $t('GENERAL_MD_EDITOR_HINT') }}</span>
			<v-spacer />
			<v-menu offset-y top left>
				<template v-slot:activator="{ on }">
					<v-btn small flat primary :disabled="!value" v-on="on">{{ $t('GENERAL_MD_EDITOR_BUTTON_PREVIEW') }}</v-btn>
				</template>
				
				<v-card class="elevation-1">
					<v-card-text class="preview" v-html="compiled" />
				</v-card>
			</v-menu>
		</v-toolbar>
	</v-card>
</template>

<script>
import { compile } from '@/utils/markdown';

export default {
	name: 'MarkdownEditor',
	props: {
		label: String,
		value: String,
		rules: { type: Array, default: () => [] },
		hideDetails: { type: Boolean, default: true },
		box: { type: Boolean, default: true },
		autoGrow: { type: Boolean, default: true },
		rows: { type: Number, default: 1 },
	},
	data() { return {
		inputFocused: false,
	}},
	computed: {
		compiled() { return compile(this.value) },
	},
	methods: {
		onInput(value) {
			this.$emit('input', value);
		},
		onChange(value) {
			this.$emit('change', value);
		},

		onFocus(e) {
			console.log('focused');
		},
	},
}
</script>


<style scoped>
	.preview {
		min-width: 300px;
		max-width: 600px;
		max-height: 400px;
		overflow: auto;
	}
</style>
